module.exports = __webpack_public_path__ + "img/Klammeräffchen.53926963.jpg";